export const moduleNamespace = 'appAmAssets';
export const routeNamespace = '/map';
